/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".leap-optional[_ngcontent-%COMP%]{color:#8e8fa6;margin-left:10px;font-size:14px}"];
export { styles as styles };
